/**
 * Kleine letters zonder leestekens; om "SAP." en "sap" niet twee keer op te
 * slaan.
 *
 * Stond in `taxonomie.repo.ts`, waar hij wel werd geëxporteerd maar nergens
 * buiten dat bestand werd gebruikt. De opdrachttabellen hebben hem ook nodig, en
 * die horen hun normalisatie niet uit een taxonomie-repository te halen. Hier
 * staat hij bij de andere pure regels, met een test.
 */
export const normaliseer = (s) => s
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .replace(/\s+/g, ' ')
    .trim();
/**
 * Zoals `normaliseer`, maar voor mensennamen: koppelteken wordt spatie en
 * accenten vallen weg. Bij een opdracht is "P&ID-tekening" iets anders dan
 * "P&ID tekening", bij een naam is "Jan-Peter" gewoon "Jan Peter". SQLite's
 * `lower()` is bovendien ASCII-only (`lower('JOËL')` geeft `joËl`), dus deze
 * vergelijking gebeurt in JavaScript en niet in de database.
 */
export const naamsleutel = (s) => normaliseer(s.replace(/-/g, ' ')).normalize('NFD').replace(/\p{M}/gu, '');
/**
 * De eerste letters van de eerste twee woorden, voor in een avatar.
 *
 * Tussenvoegsels blijven meedoen: "Jan de Vries" wordt "JD" en niet "JV". Ze
 * eruit filteren vraagt een lijst met uitzonderingen, en die klopt nooit
 * helemaal — een avatar hoeft alleen herkenbaar te zijn, niet correct af te
 * korten.
 */
export const initialen = (naam) => naam
    .split(/\s+/)
    .slice(0, 2)
    .map((deel) => deel[0]?.toUpperCase() ?? '')
    .join('');
/**
 * Tussenvoegsels en losse letters. Ze zeggen niets als je op een naam zoekt en
 * ze staan in elke zin, dus zoeken op "van" levert alleen ruis op.
 */
const TE_VAAK = new Set([
    'van',
    'de',
    'der',
    'den',
    'het',
    'ten',
    'ter',
    'te',
    'op',
    'aan',
    'bv',
    'nv',
]);
/** Korter dan dit zoeken we niet: "Wil" is nog te verdedigen, twee letters is
 *  een lettergreep in elk ander woord. */
const MINIMALE_LENGTE = 3;
/**
 * De losse woorden waarop je een naam kunt herkennen.
 *
 * Een gesprek noemt een voornaam, de administratie kent "Koen van Damme". Dus
 * per deel zoeken en niet op de hele naam. Bedrijfsnamen gaan er net zo doorheen:
 * "ProRail" is één deel, "Van Oord" wordt "oord".
 */
export function naamdelen(namen) {
    const uit = new Set();
    for (const naam of namen) {
        for (const deel of naamsleutel(naam).split(' ')) {
            if (deel.length >= MINIMALE_LENGTE && !TE_VAAK.has(deel))
                uit.add(deel);
        }
    }
    return [...uit];
}
/**
 * Welke van die namen in deze tekst staan.
 *
 * Hele woorden, hoofdletterongevoelig, accenten weggedacht. Waarschuwen en niet
 * tegenhouden: "Bas" en "Wil" zijn ook gewone woorden, en een buddy die niet
 * verder kan door een valse melding is erger dan een naam die één keer
 * doorglipt.
 */
export function vindNamen(tekst, delen) {
    const woorden = new Set(naamsleutel(tekst).split(' ').filter(Boolean));
    return delen.filter((d) => woorden.has(d));
}
